import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import Home from './pages/Home';
import AdminLogin from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import Products from './pages/admin/Products';
import Categories from './pages/admin/Categories';
import Contacts from './pages/admin/Contacts';
import Workers from './pages/admin/Workers';
import Clients from './pages/admin/Clients';
import Settings from './pages/admin/Settings';
import NotFound from './pages/NotFound';
import { ROUTES } from './lib/routes';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path={ROUTES.HOME} element={<Home />} />

          {/* Admin Routes */}
          <Route path={ROUTES.ADMIN.LOGIN} element={<AdminLogin />} />
          <Route path={ROUTES.ADMIN.DASHBOARD} element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="categories" element={<Categories />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="workers" element={<Workers />} />
            <Route path="clients" element={<Clients />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
